/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderPageTypes {
  PRIVATE = 'private',
  EVENT = 'event',
  COURSE = 'course',
}
